// Reconstructed from the supplied production build; original component names were unavailable.
import {
  CalendarIcon,
  CircleCheckBigIcon,
  ClockIcon,
  FileTextIcon,
  FunnelIcon,
  PackageIcon,
  React,
  RefreshCwIcon,
  SaveIcon,
  SearchIcon,
  SquarePenIcon,
  Trash2Icon,
  TriangleAlertIcon,
  UserIcon,
  XIcon,
  motion,
  useNavigate,
} from "../vendor/runtime.js";
import { api } from "../services/api.js";
import { ProductAnalysisDetailsForm } from "../components/ProductAnalysisDetailsForm.jsx";
const ProductDetailsPage = () => {
  const [e, t] = React.useState([]),
    [n, r] = React.useState([]),
    [a, l] = React.useState(true),
    [c, d] = React.useState(null),
    [f, h] = React.useState(""),
    [p, g] = React.useState("all"),
    [y, v] = React.useState("all"),
    [j, N] = React.useState([]),
    [b, S] = React.useState([]),
    [O, _] = React.useState(false),
    [C, A] = React.useState(null),
    [T, M] = React.useState(false),
    [k, $] = React.useState(null),
    [I, U] = React.useState({
      title: "",
      category: "",
      amount: "",
      description: "",
    }),
    [q, z] = React.useState(false),
    [Y, F] = React.useState(null),
    B = useNavigate();
  (React.useEffect(() => {
    K();
  }, []),
    React.useEffect(() => {
      Q();
    }, [f, p, y, e]));
  const K = async () => {
      try {
        l(true);
        const te = await api.get("/admin/products");
        t(te.data);
        const ye = [...new Set(te.data.map((de) => de.category))].filter(Boolean),
          V = [...new Set(te.data.map((de) => de.analysis_status))].filter(Boolean);
        (N(ye), S(V));
      } catch (te) {
        (console.error("Error fetching products:", te),
          d("Failed to load products. Please try again later."));
      } finally {
        l(false);
      }
    },
    Q = () => {
      let te = [...e];
      (f &&
        (te = te.filter((ye) => {
          var V, de;
          return (
            ((V = ye.title) == null ? undefined : V.toLowerCase().includes(f.toLowerCase())) ||
            ((de = ye.agent_name) == null ? undefined : de.toLowerCase().includes(f.toLowerCase()))
          );
        })),
        p !== "all" && (te = te.filter((ye) => ye.category === p)),
        y !== "all" && (te = te.filter((ye) => ye.analysis_status === y)),
        r(te));
    },
    ne = (te) => {
      (A(te), _(true));
    },
    L = async () => {
      if (C)
        try {
          (l(true), await api.delete(`/admin/products/${C.id}`), await K(), _(false), A(null));
        } catch (te) {
          (console.error("Error deleting product:", te),
            d("Failed to delete product. Please try again later."));
        } finally {
          l(false);
        }
    },
    ee = (te) => {
      ($(te),
        U({
          title: te.title || "",
          category: te.category || "",
          amount: te.amount || "",
          description: te.description || "",
        }),
        M(true));
    },
    re = (te) => {
      const { name: ye, value: V } = te.target;
      U((de) => ({
        ...de,
        [ye]: V,
      }));
    },
    R = async () => {
      if (k) {
        console.log(I);
        try {
          (l(true), await api.put(`/admin/products/${k.id}`, I), await K(), M(false), $(null));
        } catch (te) {
          (console.error("Error updating product:", te),
            d("Failed to update product. Please try again later."));
        } finally {
          l(false);
        }
      }
    },
    W = (te) => {
      const ye = e.map((de) => (de.id === te.id ? te : de));
      t(ye);
      const V = n.map((de) => (de.id === te.id ? te : de));
      (r(V), z(false), F(null));
    },
    xe = () => {
      (h(""), g("all"), v("all"));
    },
    ve = {
      hidden: {
        opacity: 0,
        y: 20,
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.4,
        },
      },
    };
  return a && e.length === 0 ? (
    <div className={"admin-page bg-gradient-to-br from-purple-50 to-purple-100"}>
      <div className={"flex items-center justify-center h-screen"}>
        <div className={"p-8 flex flex-col items-center"}>
          <div className={"w-16 h-16 relative"}>
            <div
              className={
                "absolute inset-0 rounded-full border-t-4 border-b-4 border-purple-600 animate-spin"
              }
            />
            <div
              className={
                "absolute inset-0 rounded-full border-r-4 border-l-4 border-purple-700 animate-pulse opacity-75"
              }
            />
          </div>
          <p className={"mt-4 text-gray-600"}>{"Loading products..."}</p>
        </div>
      </div>
    </div>
  ) : (
    <div className={"admin-page bg-gradient-to-br from-purple-50 to-purple-100"}>
      <main className="admin-main">
        <motion.div initial={"hidden"} animate={"visible"} variants={ve} className={"mb-8"}>
          <h1 className={"text-3xl font-bold text-gray-900 mb-2"}>{"Products Management"}</h1>
          <p className={"text-gray-600"}>{"Manage and review all products uploaded by agents"}</p>
        </motion.div>
        {c && (
          <motion.div initial={"hidden"} animate={"visible"} variants={ve} className={"mb-6"}>
            <div
              className={"bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded-md"}
              role={"alert"}
            >
              <p className={"font-medium"}>{"Error"}</p>
              <p>{c}</p>
            </div>
          </motion.div>
        )}
        <motion.div initial={"hidden"} animate={"visible"} variants={ve} className={"mb-6"}>
          <div className={"bg-white p-4 rounded-xl shadow-sm"}>
            <div className={"flex flex-col md:flex-row justify-between gap-4"}>
              <div className={"w-full md:w-1/3"}>
                <div className={"relative"}>
                  <div
                    className={
                      "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                    }
                  >
                    <SearchIcon className={"h-5 w-5 text-gray-400"} />
                  </div>
                  <input
                    type={"text"}
                    placeholder={"Search by title or agent name"}
                    className={
                      "pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full"
                    }
                    value={f}
                    onChange={(te) => h(te.target.value)}
                  />
                </div>
              </div>
              <div className={"flex flex-col sm:flex-row gap-4"}>
                <div className={"w-full sm:w-auto"}>
                  <div className={"relative"}>
                    <div
                      className={
                        "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                      }
                    >
                      <FunnelIcon className={"h-5 w-5 text-gray-400"} />
                    </div>
                    <select
                      className={
                        "pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full"
                      }
                      value={p}
                      onChange={(te) => g(te.target.value)}
                    >
                      <option value={"all"}>{"All Categories"}</option>
                      {j.map((te, ye) => (
                        <option key={ye} value={te}>
                          {te}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className={"w-full sm:w-auto"}>
                  <div className={"relative"}>
                    <div
                      className={
                        "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                      }
                    >
                      <ClockIcon className={"h-5 w-5 text-gray-400"} />
                    </div>
                    <select
                      className={
                        "pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full"
                      }
                      value={y}
                      onChange={(te) => v(te.target.value)}
                    >
                      <option value={"all"}>{"All Statuses"}</option>
                      {b.map((te, ye) => (
                        <option key={ye} value={te}>
                          {te}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <button
                  onClick={xe}
                  className={
                    "px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 flex items-center"
                  }
                >
                  <XIcon className={"h-5 w-5 mr-2"} />
                  {"Clear Filters"}
                </button>
                <button
                  onClick={K}
                  className={
                    "px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center"
                  }
                >
                  <RefreshCwIcon className={"h-5 w-5 mr-2"} />
                  {"Refresh"}
                </button>
              </div>
            </div>
          </div>
        </motion.div>
        <motion.div initial={"hidden"} animate={"visible"} variants={ve}>
          {n.length > 0 ? (
            <div className={"bg-white rounded-2xl shadow-lg overflow-hidden"}>
              <div className={"overflow-x-auto"}>
                <table className={"min-w-full divide-y divide-gray-200"}>
                  <thead>
                    <tr>
                      <th
                        scope={"col"}
                        className={
                          "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                        }
                      >
                        {"Product"}
                      </th>
                      <th
                        scope={"col"}
                        className={
                          "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                        }
                      >
                        {"Agent"}
                      </th>
                      <th
                        scope={"col"}
                        className={
                          "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                        }
                      >
                        {"Category"}
                      </th>
                      <th
                        scope={"col"}
                        className={
                          "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                        }
                      >
                        {"Date"}
                      </th>
                      <th
                        scope={"col"}
                        className={
                          "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                        }
                      >
                        {"Price"}
                      </th>
                      <th
                        scope={"col"}
                        className={
                          "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                        }
                      >
                        {"Analysis Status"}
                      </th>
                      <th
                        scope={"col"}
                        className={
                          "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                        }
                      >
                        {"Actions"}
                      </th>
                    </tr>
                  </thead>
                  <tbody className={"bg-white divide-y divide-gray-200"}>
                    {n.map((te) => (
                      <tr
                        key={te.id || Math.random().toString()}
                        className={"hover:bg-gray-50 transition duration-150"}
                      >
                        <td className={"px-6 py-4 whitespace-nowrap"}>
                          <div className={"flex items-center"}>
                            <div
                              className={
                                "flex-shrink-0 h-10 w-10 bg-gradient-to-br from-purple-500 to-purple-700 rounded-lg flex items-center justify-center text-white font-bold"
                              }
                            >
                              {te.title ? te.title.charAt(0).toUpperCase() : "P"}
                            </div>
                            <div className={"ml-4"}>
                              <div className={"text-sm font-medium text-gray-900"}>
                                {te.title || "Unnamed Product"}
                              </div>
                              <div className={"text-xs text-gray-500"}>
                                {"ID: "}
                                {te.id || "N/A"}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className={"px-6 py-4 whitespace-nowrap"}>
                          <div className={"flex items-center"}>
                            <div
                              className={
                                "flex-shrink-0 h-8 w-8 bg-gray-100 rounded-full flex items-center justify-center"
                              }
                            >
                              <UserIcon className={"h-4 w-4 text-gray-500"} />
                            </div>
                            <div className={"ml-3"}>
                              <div className={"text-sm text-gray-900"}>
                                {te.agent_name || "Unknown"}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className={"px-6 py-4 whitespace-nowrap"}>
                          <span
                            className={
                              "px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-purple-100 text-purple-800"
                            }
                          >
                            {te.category || "Uncategorized"}
                          </span>
                        </td>
                        <td className={"px-6 py-4 whitespace-nowrap"}>
                          <div className={"text-sm text-gray-600 flex items-center"}>
                            <CalendarIcon className={"w-4 h-4 mr-1 text-gray-400"} />
                            {te.created_at ? new Date(te.created_at).toLocaleDateString() : "N/A"}
                          </div>
                        </td>
                        <td className={"px-6 py-4 whitespace-nowrap"}>
                          <div className={"text-sm font-medium text-gray-900"}>
                            {"₹"}
                            {typeof te.amount == "number" || typeof te.amount == "string"
                              ? parseFloat(te.amount).toFixed(2)
                              : "0.00"}
                          </div>
                        </td>
                        <td className={"px-6 py-4 whitespace-nowrap"}>
                          <span
                            className={`px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full items-center
                            ${te.analysis_status === "completed" ? "bg-green-100 text-green-800" : te.analysis_status === "pending" ? "bg-yellow-100 text-yellow-800" : te.analysis_status === "in_progress" ? "bg-purple-200 text-purple-900" : te.analysis_status === "failed" ? "bg-red-100 text-red-800" : "bg-gray-100 text-gray-800"}`}
                          >
                            {te.analysis_status === "completed" && (
                              <CircleCheckBigIcon className={"w-3 h-3 mr-1"} />
                            )}
                            {te.analysis_status === "pending" && (
                              <ClockIcon className={"w-3 h-3 mr-1"} />
                            )}
                            {te.analysis_status === "in_progress" && (
                              <RefreshCwIcon className={"w-3 h-3 mr-1"} />
                            )}
                            {te.analysis_status === "failed" && (
                              <TriangleAlertIcon className={"w-3 h-3 mr-1"} />
                            )}
                            {te.analysis_status
                              ? te.analysis_status.charAt(0).toUpperCase() +
                                te.analysis_status.slice(1)
                              : "Not Analyzed"}
                          </span>
                        </td>
                        <td className={"px-6 py-4 whitespace-nowrap text-sm font-medium"}>
                          <div className={"flex space-x-2"}>
                            <button
                              onClick={() => B(`/admin/products/${te.id}`)}
                              className={
                                "p-2 bg-purple-50 text-purple-600 rounded-lg hover:bg-purple-100 transition-colors flex items-center"
                              }
                              title={"View Details"}
                            >
                              <FileTextIcon className={"h-4 w-4"} />
                            </button>
                            <button
                              onClick={() => ee(te)}
                              className={
                                "p-2 bg-purple-100 text-purple-800 rounded-lg hover:bg-purple-200 transition-colors flex items-center"
                              }
                              title={"Edit Product"}
                            >
                              <SquarePenIcon className={"h-4 w-4"} />
                            </button>
                            <button
                              onClick={() => B(`/admin/products/${te.id}/analysis`)}
                              className={
                                "p-2 bg-purple-50 text-purple-600 rounded-lg hover:bg-purple-100 transition-colors flex items-center"
                              }
                              title={"Update Analysis Status"}
                            >
                              <ClockIcon className={"h-4 w-4"} />
                            </button>
                            <button
                              onClick={() => ne(te)}
                              className={
                                "p-2 bg-red-50 text-red-600 rounded-lg hover:bg-red-100 transition-colors flex items-center"
                              }
                              title={"Delete Product"}
                            >
                              <Trash2Icon className={"h-4 w-4"} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div className={"bg-white rounded-2xl shadow-lg p-12 text-center"}>
              <div className={"flex flex-col items-center justify-center"}>
                <div
                  className={
                    "w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center text-gray-400 mb-6"
                  }
                >
                  <PackageIcon className={"h-12 w-12"} />
                </div>
                <h3 className={"text-xl font-bold text-gray-800 mb-2"}>{"No Products Found"}</h3>
                <p className={"text-gray-500 mb-6"}>
                  {f || p !== "all" || y !== "all"
                    ? "No products match your filters. Try adjusting your search criteria."
                    : "There are no products in the system yet."}
                </p>
                <button
                  onClick={xe}
                  className={
                    "px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center"
                  }
                >
                  <RefreshCwIcon className={"h-5 w-5 mr-2"} />
                  {f || p !== "all" || y !== "all" ? "Clear Filters" : "Refresh"}
                </button>
              </div>
            </div>
          )}
        </motion.div>
      </main>
      {O && (
        <div
          className={"fixed inset-0 bg-black/50 flex items-center justify-center z-50"}
        >
          <div className={"bg-white rounded-lg shadow-xl max-w-md w-full p-6"}>
            <h3 className={"text-lg font-bold text-gray-900 mb-4"}>{"Confirm Deletion"}</h3>
            <div className={"mb-6"}>
              <p className={"text-gray-600 mb-4"}>
                {
                  "Are you sure you want to delete the following product? This action cannot be undone."
                }
              </p>
              <div className={"bg-red-50 p-4 rounded-lg"}>
                <div className={"flex items-center mb-2"}>
                  <div
                    className={
                      "flex-shrink-0 h-8 w-8 bg-red-100 rounded-lg flex items-center justify-center text-red-500 mr-3"
                    }
                  >
                    <PackageIcon className={"h-4 w-4"} />
                  </div>
                  <div className={"font-medium text-red-800"}>
                    {C == null ? undefined : C.title}
                  </div>
                </div>
                <div className={"text-sm text-red-700 ml-11"}>
                  <p>
                    {"ID: "}
                    {C == null ? undefined : C.id}
                  </p>
                  <p>
                    {"Agent: "}
                    {C == null ? undefined : C.agent_name}
                  </p>
                </div>
              </div>
            </div>
            <div className={"flex justify-end space-x-3"}>
              <button
                onClick={() => _(false)}
                className={
                  "px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                }
              >
                {"Cancel"}
              </button>
              <button
                onClick={L}
                className={
                  "px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 flex items-center"
                }
                disabled={a}
              >
                <Trash2Icon className={"h-5 w-5 mr-2"} />
                {a ? "Deleting..." : "Delete Product"}
              </button>
            </div>
          </div>
        </div>
      )}
      {T && (
        <div
          className={"fixed inset-0 bg-black/50 flex items-center justify-center z-50"}
        >
          <div className={"bg-white rounded-lg shadow-xl max-w-lg w-full p-6"}>
            <h3 className={"text-lg font-bold text-gray-900 mb-4"}>{"Edit Product"}</h3>
            <div className={"mb-6 space-y-4"}>
              <div>
                <label className={"block text-sm font-medium text-gray-700 mb-1"}>
                  {"Product Title"}
                </label>
                <input
                  type={"text"}
                  name={"title"}
                  value={I.title}
                  onChange={re}
                  className={
                    "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500"
                  }
                />
              </div>
              <div>
                <label className={"block text-sm font-medium text-gray-700 mb-1"}>
                  {"Category"}
                </label>
                <select
                  name={"category"}
                  value={I.category}
                  onChange={re}
                  className={
                    "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500"
                  }
                >
                  <option value={""}>{"Select a category"}</option>
                  {j.map((te, ye) => (
                    <option key={ye} value={te}>
                      {te}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className={"block text-sm font-medium text-gray-700 mb-1"}>
                  {"Price (₹)"}
                </label>
                <input
                  type={"number"}
                  name={"amount"}
                  value={I.amount}
                  onChange={re}
                  className={
                    "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500"
                  }
                />
              </div>
              <div>
                <label className={"block text-sm font-medium text-gray-700 mb-1"}>
                  {"Description"}
                </label>
                <textarea
                  name={"description"}
                  value={I.description}
                  onChange={re}
                  rows={"3"}
                  className={
                    "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500"
                  }
                />
              </div>
            </div>
            <div className={"flex justify-end space-x-3"}>
              <button
                onClick={() => M(false)}
                className={
                  "px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                }
              >
                {"Cancel"}
              </button>
              <button
                onClick={R}
                className={
                  "px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center"
                }
                disabled={a}
              >
                <SaveIcon className={"h-5 w-5 mr-2"} />
                {a ? "Saving..." : "Save Changes"}
              </button>
            </div>
          </div>
        </div>
      )}
      {q && (
        <div
          className={"fixed inset-0 bg-black/50 flex items-center justify-center z-50"}
        >
          <div className={"bg-white rounded-lg shadow-xl max-w-md w-full p-6"}>
            <div className={"flex justify-between items-center mb-4"}>
              <h3 className={"text-lg font-bold text-gray-900"}>{"Update Analysis Status"}</h3>
              <button onClick={() => z(false)} className={"text-gray-400 hover:text-gray-500"}>
                <XIcon className={"h-6 w-6"} />
              </button>
            </div>
            <div className={"mb-4 bg-gray-50 p-4 rounded-lg"}>
              <div className={"flex items-center"}>
                <div
                  className={
                    "flex-shrink-0 h-10 w-10 bg-gradient-to-br from-purple-500 to-purple-700 rounded-lg flex items-center justify-center text-white font-bold"
                  }
                >
                  {Y != null && Y.title ? Y.title.charAt(0).toUpperCase() : "P"}
                </div>
                <div className={"ml-4"}>
                  <div className={"text-sm font-medium text-gray-900"}>
                    {(Y == null ? undefined : Y.title) || "Unnamed Product"}
                  </div>
                  <div className={"flex space-x-4 text-xs text-gray-500"}>
                    <span>
                      {"ID: "}
                      {(Y == null ? undefined : Y.id) || "N/A"}
                    </span>
                    <span>
                      {"Agent: "}
                      {(Y == null ? undefined : Y.agent_name) || "Unknown"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <ProductAnalysisDetailsForm product={Y} onUpdate={W} />
          </div>
        </div>
      )}
    </div>
  );
};
export { ProductDetailsPage };
